import { Component, Input } from '@angular/core';
import { ConnectionChangeDto } from '@bo-client/shared/models/connectionChange.dto';

@Component({
  selector: 'app-order-request-wizard-summary',
  templateUrl: './order-request-wizard-summary.component.html',
  styleUrl: './order-request-wizard-summary.component.scss'
})
export class OrderRequestWizardSummaryComponent {
  @Input() model: ConnectionChangeDto = null;
}
